



























import { Prop, Vue } from 'vue-property-decorator'
import Component from 'vue-class-component'

@Component
export default class AsyncSelect extends Vue {
  @Prop(String)
  label: string

  @Prop(Array)
  options: any[]

  @Prop(Number)
  value: number

  @Prop(Boolean)
  disabled: boolean

  @Prop(String)
  errorMessage: string

  emitInput(value: string) {
    this.$emit('input', value)
  }

  emitFilter(query: string, update: Function, abort: Function) {
    this.$emit('filter', query, update, abort)
  }
}
